module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3e834216ad9aa6769a6db38654b21b8c.png";